import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Link } from 'react-router-dom'
import { Select } from 'antd/lib/select'
import StatusCell from '../../../../elements/Table/Cells/StatusCell'
import StatusFilter, { statusFilterMethod } from '../../../../components/Sales/Orders/TableComponents/StatusFilter'
import DateCell from '../../../../elements/Table/Cells/DateCell'

const CheckboxTable = checkboxHOC(CustomTable)

function List(props) {
  const { list, fetch, selectAll, isSelected, toggleSelection, toggleAll, fetching, tableRef, onShow } = props
  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  const columns = [
    {
      Header: 'System ID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Order',
      accessor: 'order.code',
      Cell: ({ original, value }) => (
        <Link
          target={'_blank'}
          to={{
            pathname: `/clients/orders/bookings/${original.order._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'CPO No',
      accessor: 'order.cpo.no',
    },
    {
      Header: 'Client Ref',
      accessor: 'order.reference.no',
    },
    {
      Header: 'Client Budget Line',
      accessor: 'clientBudget.name',
      hideable: true,
      width: 300,
    },
    {
      Header: 'Name',
      accessor: 'name',
      style: { textAlign: 'left' },
      width: 300,
    },
    {
      Header: 'Pick up Date',
      accessor: 'booking.pickup.date',
      Cell: DateCell,
    },
    {
      Header: 'Drop off',
      accessor: 'booking.dropoff.date',
      Cell: DateCell,
    },
    {
      Header: 'Vehicle Name',
      accessor: 'booking.vehicle.details',
    },
    {
      Header: 'Vehicle Plate',
      accessor: 'booking.vehicle.plate',
    },
    {
      Header: 'Driver',
      accessor: 'booking.vehicle.driver.driverName',
    },
    {
      Header: 'Driver Phone',
      accessor: 'booking.vehicle.driver.driverPhone',
    },
    {
      Header: 'Fuel Tag',
      accessor: 'booking.vehicle.fuelTag',
      hideable: true,
      hideDefault: true,
    },

    {
      Header: 'Order Status',
      accessor: 'order.status',
      hideable: true,
      hideDefault: true,
      width: 150,
      Cell: StatusCell,
      filterMethod: statusFilterMethod,
      Filter: StatusFilter,
    },
  ]

  return (
    <CheckboxTable
      {...checkboxProps}
      withRef={tableRef}
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
